<template>
  <div class="custom-container-xl d-flex-100 home-cat-search-wrap" v-if="shouldRender">
    <div class="custom-container-xl pos-rel home-cat-search-header" :class="wrapperClass">
      <h3 class="db-100 pos-rel">
        {{ t(groupTitle, { namespace: 'GlassesFilteringComponent' }) }}
      </h3>
    <div class="category-filter">
      <div class="filter-wrapper-title" v-for="(category, index) in this.categories" :key="category.id"
        @click="setSelectedCategory(category.slug)">
        <div v-if="index !== 0" class="text-uppercase category category-link" :class="{ 'active': isSelectedCategory(category.slug) }">
          {{ category.name }}
        </div>
      </div>
    </div>
    <div class="filter-titles-wrapper">
      <div class="d-flex flex-wrap align-items-center justify-content-center filter-title">Brands</div>
      <div class="d-flex flex-wrap align-items-center justify-content-center filter-title" v-for="(tagGroup, key) in this.groupedTags" :key="key">
        <div class="home-cat-search-col-header-title">
          {{ groupedTags[key].GroupCatName }}
        </div>
      </div>
    </div>
    <div class="filter-items-wrapper">
      <div class="tag-values-wrapper homeSearchCheckBoxWrap">
        <input type="text" v-model="searchQuery" placeholder="Search vendors" class="search-input-item form-control" />
        <div class="text-center tag-values-item-vendor checkbox" v-for="filteredVendor in filteredVendors"
          :key="filteredVendor.id">
          <input :id="uniqueIdPrefix(filteredVendor.id)" type="checkbox"
                 @click="toggleVendorSelection(filteredVendor.vendor_slug)"
                 class="checkbox-input"
                 :class="isActiveVendor(filteredVendor.vendor_slug)">
          <label :for="uniqueIdPrefix(filteredVendor.id)">{{ filteredVendor.name }}</label>
        </div>
      </div>
      <div class="tag-values-wrapper homeSearchCheckBoxWrap" v-for="(tagGroup, key) in this.groupedTags" :key="key">
        <div class="text-center tag-values-item checkbox" v-for="tag in tagGroup.tags" :key="tag.id"
          @click="toggleTagSelection(tagGroup.GroupCatSlug, tag.slug, tagGroup.GroupCatId)"
          :class="{ 'active': isSelectedTag(tagGroup.GroupCatSlug, tag.slug, tagGroup.GroupCatId), 'tag-values-item-with-image': tag.tag_image }">
          <div v-if="tag.tag_image" class="tag-image">
            <img :src="getProductImageUrl(tag.tag_image)" :alt="tag.name" class="home-cat-search-img">
            <span>{{ tag.name }}</span>
          </div>
          <div class="db-100 text-left" v-else>
            <span class="db-100 tag-values-item-name">{{ tag.name }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-3 col-12 home-cat-search-total prod-total-number">
      <div class="all-cats-no-text">
        <div v-show="this.productsCount > 0">
          {{ this.productsCount }} {{ t(totalNumberOfProductsLang, { namespace: 'GlassesFilteringComponent' }) }}
        </div>
        <a :href="this.url" v-if="this.productsCount > 0"
           :class="this.section === 'glasses' ? 'glasses-background-see-more-button' : ''">
          {{ t('see.more.button.glasses', { namespace: 'GlassesFilteringComponent' }) }}
        </a>
      </div>
      <div v-show="this.productsCount < 1" class="no-products-found-wrapper">
          {{ t('no.products.found', { namespace: 'GlassesFilteringComponent' }) }}
      </div>
    </div>
    </div>
  </div>
</template>

<script>
import glassesGroupFilteringMixin from '../mixins/glassesGroupFilteringMixin'
export default {
  name: 'GlassesGroupFiltering',
  mixins: [glassesGroupFilteringMixin],
  data () {
    return {
      shouldRender: window.innerWidth > 768
    }
  }
}
</script>

<style scoped>
.filter-titles-wrapper {
  user-select: none;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  background: black;
  color: white;
  border-radius: 36px;
  padding: 15px;
  margin-bottom: 1rem;
  @media screen and (max-width: 767px) {
    display: none
  }
}

.filter-items-wrapper {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 1rem;
  width: 100%;
  padding: 0 15px;
  @media screen and (min-width:1400px){
    width:70%
  }
  @media screen and (max-width: 767px) {
    grid-template-columns: 1fr;
  }
}

.filter-wrapper-title {
  font-size: clamp(1rem, 2.5vw, 19px);
  font-weight: 700;
  @media screen and (min-width:1400px) and (max-width:1599px){
    font-size:20px
  }
}

.filter-title {
  font-size: clamp(13px, 2.5vw, 25px);
  padding-top:10px;
  padding-bottom:10px;
  @media screen and (min-width:1400px) and (max-width:1599px){
    font-size:20px
  }
  @media screen and (min-width:768px) and (max-width:1199px){
    font-size: clamp(13px, 2.5vw, 20px)
  }
}

.tag-values-item {
  background: #D9D9D9;
  padding: clamp(10px, 2.5vw, 12px);
  border-radius: 20px;
  cursor: pointer;
}
.tag-values-item-name{
  @media screen and (min-width:1200px) and (max-width:1599px){
    font-size: 15px
  }
}
.tag-values-item-vendor {
  display: grid;
  grid-template-columns: 13px auto;
  justify-content: start;
  align-items: center;
  grid-gap: 10px;
  position: relative;
  label {
    margin: 0;
    width: 100%;
    padding-left: 10px;
    overflow:hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    &:before {
      content: '';
      -webkit-appearance: none;
      background-color: #F7F7F7;
      border: 2px solid var(--prime1);
      padding: 10px;
      position: absolute;
      cursor: pointer;
      margin-right: 5px;
      left: 0;
      top: 0;
      width: 22px;
      height: 22px;
      border-radius: 3px;
    }
  }

  input.active {
    width: 0;

    &:checked+label {
      &:before {
        background-color: var(--prime1)
      }

      &:after {
        content: '';
        position: absolute;
        top: 2px;
        left: 8px;
        width: 8px;
        height: 16px;
        border: solid var(--prime2);
        border-width: 0 2px 2px 0;
        transform: rotate(45deg)
      }
    }
  }
}

.category {
  cursor: pointer;
  margin: 10px 5px 10px 0
}

.tag-values-item.active {
  background: #FFCC1CFF;
}

.search-input-item {
  width: 100%;
  background: #FFFFFF;
  border: 1px solid #d9d9d9;
  padding: 15px;
  border-radius: 36px;
  margin: 0 0 15px 0;
}

.category-link {
  outline: none !important;
  transition: 0.4s;
  padding:5px 15px;
  border-radius:36px;
  text-align: center
}

.category-link:hover,
.category-link.active,
.category-link:focus {
  background: var(--prime2);
  color:var(--prime1)
}

.tag-image {
  display: grid;
  grid-template-columns: 1fr 1fr;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  width: 100%;
  justify-items: center;

  img {
    width: 60px;
    height: 53px;
    object-fit: contain;
  }
}

.prod-total-number {
  @media screen and (max-width: 768px) {
    display: none;
  }
}

.category-filter {
  display: grid;
  width:100%;
  grid-template-columns: repeat(4, 1fr);
  @media screen and (min-width:1400px){
    width:70%
  }
  @media screen and (max-width: 767px) {
    grid-template-columns: repeat(2, 1fr);
    margin-bottom: 10px;
  }
}

.filter-titles-wrapper {
  width: 100%;
  padding: 0 15px;
  @media screen and (min-width:1400px){
    width:70%
  }
}

.homeSearchCheckBoxWrap {
  overflow-y: scroll;
  scrollbar-width: thin;
  scrollbar-color: #ffc800 #f7f7f7;
  border-radius:10px;
  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #ffc800;
    border-radius: 21px;

  }
}

.homepage-glasses-section-wrapper .no-products-found-wrapper {
  color: #F2F2F2;
}
</style>
